<template>
  <div class="con-wrap">
    <el-form
      size="medium"
      :inline="true"
      :model="queryForm"
      ref="queryForm"
      class="input-form-inline"
      @submit.native.prevent
    >
      <div>
        <el-form-item class="r-20" prop="deviceId">
          <el-input
            v-model="queryForm.deviceId"
            @keyup.enter.native="query"
            placeholder="设备编号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="deviceModel">
          <el-input
            v-model="queryForm.deviceModel"
            @keyup.enter.native="query"
            placeholder="设备型号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="softVer">
          <el-input
            v-model="queryForm.softVer"
            @keyup.enter.native="query"
            placeholder="软件版本号"
          ></el-input>
        </el-form-item>
        <el-form-item class="r-20" prop="hardVer">
          <el-input
            v-model="queryForm.hardVer"
            @keyup.enter.native="query"
            placeholder="硬件版本号"
          ></el-input>
        </el-form-item>
        <el-button
          v-if="hasPerm('upgrade:issued:list')"
          type="primary"
          @click="query"
          >查询</el-button
        >
        <el-button v-if="hasPerm('upgrade:issued:list')" @click="reset"
          >取消</el-button
        >
      </div>

      <div style="margin-bottom: 20px">
        <el-button
          size="medium"
          v-if="hasPerm('upgrade:issued:push')"
          type="primary"
          @click="issueUpgradeBtn"
          >下发升级</el-button
        >
      </div>
    </el-form>
    <el-table
      ref="multipleTable"
      :data="tableData"
      tooltip-effect="dark"
      style="width: 100%"
      size="mini"
      stripe
      height="560px"
      @row-click="handleClickTableRow"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        width="24"
        align="center"
        style="padding: 0"
      ></el-table-column>
      <el-table-column type="index" label="序号" width="55"></el-table-column>
      <el-table-column prop="deviceId" label="设备编号"></el-table-column>
      <el-table-column prop="deviceModel" label="设备型号"></el-table-column>
      <el-table-column prop="vehicleModel" label="车辆型号"></el-table-column>
      <el-table-column prop="vin" label="车架号"></el-table-column>
      <el-table-column
        prop="softVer"
        label="软件版本号"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="hardVer"
        label="硬件版本号"
        show-overflow-tooltip
      ></el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-size="limit"
      layout="total, prev, pager, next, jumper"
      :total="total"
    ></el-pagination>
    <!-- 下发升级 -->
    <el-dialog
      title="选择升级包"
      :visible.sync="issueUpgradeVisible"
      class="issue-dialog"
      v-if="step == 1"
    >
      <div id="first-step">
        <el-table
          ref="packageTable"
          :data="packageData"
          tooltip-effect="dark"
          style="width: 100%"
          size="mini"
          stripe
          height="534px"
          @row-click="packageClickTableRow"
          @selection-change="packageSelectionChange"
        >
          <el-table-column
            type="selection"
            width="24"
            align="center"
            style="padding: 0"
          ></el-table-column>
          <el-table-column
            type="index"
            label="序号"
            width="55"
          ></el-table-column>
          <el-table-column
            prop="vehicleModel"
            label="车辆型号"
          ></el-table-column>
          <el-table-column
            prop="deviceModel"
            label="设备型号"
          ></el-table-column>
          <el-table-column prop="type" label="升级包类型"></el-table-column>
          <el-table-column
            prop="fileName"
            label="升级包文件名"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column prop="softVer" label="软件版本号"></el-table-column>
          <el-table-column
            prop="hardVer"
            label="硬件版本号"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            prop="md5"
            label="MD5"
            show-overflow-tooltip
          ></el-table-column>
        </el-table>
        <el-pagination
          @size-change="packageSizeChange"
          @current-change="packageCurrentChange"
          :current-page.sync="packageCurrentPage"
          :page-size="limit"
          layout="total, prev, pager, next, jumper"
          :total="packagetotal"
        ></el-pagination>
        <div style="text-align:right;margin-top:20px">
          <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="nextStep">下一步</el-button>
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      title="下发升级"
      :visible.sync="issueUpgradeVisible"
      class="vehicle-dialog"
      v-else
    >
      <div id="last-step">
        <el-form
          :rules="issueRules"
          ref="issueForm"
          :model="issueForm"
          size="mini"
          :inline="true"
        >
          <el-form-item label="车辆型号" style="margin-bottom:0 !important">
            {{ packageVal[0].vehicleModel }}
          </el-form-item>
          <el-form-item label="设备型号" style="margin-bottom:0 !important">
            {{ packageVal[0].deviceModel }}
          </el-form-item>
          <el-form-item label="升级包类型" style="margin-bottom:0 !important">
            {{ packageVal[0].type }}
          </el-form-item>
          <el-form-item label="升级包文件名" style="margin-bottom:0 !important">
            {{ packageVal[0].fileName }}
          </el-form-item>
          <el-form-item prop="md5" label="MD5校验">
            <el-input v-model="issueForm.md5" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="softVer" label="软件版本号">
            <el-input
              v-model="issueForm.softVer"
              placeholder="请输入"
            ></el-input>
          </el-form-item>
          <el-form-item prop="url" label="URL">
            <el-input v-model="issueForm.url" placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item prop="tsr" label="TSR">
            <el-input v-model="issueForm.tsr" placeholder="请输入"></el-input>
          </el-form-item>
          <div style="text-align:right">
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="issueCommit"
                >下发升级</el-button
              >
            </span>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      queryForm: {},
      currentPage: 1,
      limit: 10,
      total: 0,
      tableVal: [],
      tableData: [],
      issueUpgradeVisible: false,
      packageData: [],
      packageVal: [],
      packageCurrentPage: 1,
      packagetotal: 0,
      step: 1,
      formDeviceId: "",
      issueRules: {
        md5: [
          {
            required: true,
            trigger: "change",
            message: "请输入MD5校验码",
          },
        ],
        softVer: [
          {
            required: true,
            trigger: "change",
            message: "请输入软件版本号",
          },
        ],
        url: [
          {
            required: true,
            trigger: "change",
            message: "请输入URL",
          },
        ],
      },
      issueForm: {
        md5: "",
        softVer: "",
        url: "",
        tsr: "",
      },
    }
  },
  created() {
    this.getIssueList()
    this.getPackageList()
  },
  methods: {
    async getIssueList() {
      let _this = this
      let obj = {}
      obj.deviceId = _this.queryForm.deviceId
      obj.deviceModel = _this.queryForm.deviceModel
      obj.softVer = _this.queryForm.softVer
      obj.hardVer = _this.queryForm.hardVer
      obj.limit = _this.limit
      obj.page = _this.currentPage
      let { data: res } = await _this.$axios.get("/api/upgrade/issued/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.tableData = res.data.list
        _this.total = res.data.totalCount
      }
    },
    async getPackageList() {
      let _this = this
      let obj = {}
      obj.vehicleModel = ""
      obj.deviceModel = ""
      obj.limit = _this.limit
      obj.page = _this.packageCurrentPage
      let { data: res } = await _this.$axios.get("/api/upgrade/package/list", {
        params: obj,
      })
      if (res.code == 1) {
        _this.packageData = res.data.list
        _this.packagetotal = res.data.totalCount
      }
    },
    nextStep() {
      if (this.packageVal.length > 1) {
        this.$message.warning("只能选择一条数据")
        return
      }
      let id = this.$getIds(this.packageVal)
      if (!id) {
        return
      }
      this.issueForm.md5 = this.packageVal[0].md5
      this.issueForm.softVer = this.packageVal[0].softVer
      this.issueForm.url = this.packageVal[0].url
      this.issueForm.tsr = this.packageVal[0].releaseTime
      this.step = 2
    },
    query() {
      this.getIssueList()
    },
    reset() {
      this.$resetForm(this, "queryForm")
      this.getIssueList()
    },
    issueUpgradeBtn() {
      //let _this = this
      if (this.tableVal.length > 1) {
        this.$message.warning("只能选择一条数据")
        return
      }
      let id = this.$getIds(this.tableVal)
      if (!id) {
        return
      }
      console.log(this.tableVal)
      this.formDeviceId = this.tableVal[0].deviceId
      if (!this.formDeviceId) {
        return
      }
      this.step = 1
      this.issueUpgradeVisible = true
    },
    issueCommit() {
      let _this = this
      this.issueForm.deviceId = this.formDeviceId
      this.issueForm.upgradeId = this.packageVal[0].id
      _this.$refs.issueForm.validate(async (valid) => {
        if (valid) {
          let { data: res } = await _this.$axios.post(
            "/api/upgrade/issued/push",
            _this.issueForm
          )
          if (res.code == 1) {
            _this.issueUpgradeVisible = false
            _this.$resetForm(_this, "issueForm")
            _this.getIssueList()
            _this.$message.success("操作成功")
          } else {
            _this.$message.warning(res.msg)
          }
        }
      })
    },
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val
    },
    handleClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.currentPage = val
      this.getIssueList()
    },
    //选择升级包
    //选择数据变化监控
    packageSelectionChange(val) {
      this.packageVal = val
    },
    packageClickTableRow(row, event, column) {
      console.log(row)
      console.log(column)
      this.$refs.packageTable.toggleRowSelection(row)
    },
    //pagesize改变时触发
    packageSizeChange(val) {
      console.log(`每页 ${val} 条`)
    },
    //页数改变时触发
    packageCurrentChange(val) {
      console.log(`当前页: ${val}`)
      this.packageCurrentPage = val
      this.getPackageList()
    },
  },
}
</script>

<style lang="scss" scoped>
.con-wrap {
  padding: 0 20px;
  background: #fff;
}
.issue-dialog /deep/ .el-dialog {
  width: 900px;
}
.vehicle-dialog /deep/ .el-dialog {
  width: 600px;
}
.vehicle-dialog /deep/ .el-form-item__label {
  width: 140px;
  height: 32px;
  margin-left: 20px;
  text-align: left;
  color: #343434;
  font-size: 14px;
}
.vehicle-dialog /deep/ .el-form-item__content {
  width: 360px;
  height: auto;
}
</style>
